import { render, staticRenderFns } from "./ModuleLegend.vue?vue&type=template&id=0c461221&scoped=true&"
import script from "./ModuleLegend.vue?vue&type=script&lang=js&"
export * from "./ModuleLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c461221",
  null
  
)

export default component.exports